import {
    IS_GAMER_CARD_LOADING,
    GAMER_CARD_HAS_ERROR,
    GAMER_CARD_FETCH_DATA_SUCCESS,
    IS_PLAYER_LOADING,
    PLAYERS_HAS_ERROR,
    PLAYERS_FETCH_DATA_SUCCESS,
    IS_SUBSCRIBE_LOADING,
    SUBSCRIBE_HAS_ERROR,
    SUBSCRIBE_FETCH_DATA_SUCCESS,
    IS_EDITORIAL_CARD_LOADING,
    EDITORIAL_CARD_FETCH_DATA_SUCCESS,
    EDITORIAL_CARD_HAS_ERROR,
    IS_DREAM_TEAM_LOADING,
    DREAM_TEAM_HAS_ERROR,
    DREAM_TEAM_SUCCESS,
    IS_EOS_LOADING,
    EOS_FETCH_DATA_SUCCESS,
    EOS_HAS_ERROR
} from './../constants/action-types';
import { groupBy } from 'lodash';
import common from '../common';

const initialState = {
    isLoadingGamerard: false,
    isErrorGamerard: false,
    isSuccessGamerard: false,
    gamerCardData: null,
    isPlayersLoading: false,
    hasError: false,
    players: null,
    teams: null,
    isLoadingSubscribe: false,
    isErrorSubscribe: false,
    isSuccessSubscribe: false,
    objSubscribe: null,
    isLoadingEditorial: false,
    isErrorEditorial: false,
    isSuccessEditorial: false,
    editorialData: null,
    isDreamTeamLoading: false,
    dreamTeamHasError: false,
    dreamTeam: [],
    isEosLoading: false,
    eosHasError: false,
    finalPoints: [],
    eosStats: {},
    playerRecomendation: false,
};
export default function homeData(state = initialState, action) {
    switch (action.type) {
        case GAMER_CARD_FETCH_DATA_SUCCESS:
            return {
                ...state,
                isLoadingGamerard: false,
                isErrorGamerard: false,
                isSuccessGamerard: true,
                //errorGamerCard: null,
                gamerCardData: action.payload
            };
        case GAMER_CARD_HAS_ERROR:
            return {
                ...state,
                isLoadingGamerard: false,
                isErrorGamerard: true,
                isSuccessGamerard: false,
                //errorGamerCard: action.payload,
                //gamerCardData: null
            };
        case IS_GAMER_CARD_LOADING:
            return {
                ...state,
                isLoadingGamerard: true,
                isErrorGamerard: false,
                isSuccessGamerard: false,
                //errorGamerCard: null,
                //gamerCardData: null
            };
        case IS_PLAYER_LOADING: {
            return { ...state, isPlayersLoading: action.payload };
        }
        case PLAYERS_HAS_ERROR:
            return { ...state, hasError: action.payload };
        case PLAYERS_FETCH_DATA_SUCCESS: {
            const payload = action.payload['Data']['Value'];
            const players = payload.playerList;
            const groupedPlayers = groupBy(players, 'Skill');
            const playerRecomendation = payload.PlayerRecom ? payload.PlayerRecom : true;
            // common.updateBusters('/bust-after-status-change');
            // let IsFirstTimeRecomend = false;
            // if (common.getLocalStorage("IsFirstTimeRecomend")) {
            //     if (common.getLocalStorage("IsFirstTimeRecomend") == false) {
            //         IsFirstTimeRecomend = false;
            //     }
            // } else {
            //     common.setLocalStorage('IsFirstTimeRecomend', true);
            //     IsFirstTimeRecomend = true;
            // }

            return { ...state, players, groupedPlayers, teams: payload['teamsList'], playerRecomendation };
        }
        //
        case SUBSCRIBE_FETCH_DATA_SUCCESS:
            return {
                ...state,
                isLoadingSubscribe: false,
                isErrorSubscribe: false,
                isSuccessSubscribe: true,
                objSubscribe: action.payload
            };
        case SUBSCRIBE_HAS_ERROR:
            return {
                ...state,
                isLoadingSubscribe: false,
                isErrorSubscribe: true,
                isSuccessSubscribe: false,
                //errorGamerCard: action.payload,
                objSubscribe: null
            };
        case IS_SUBSCRIBE_LOADING:
            return {
                ...state,
                isLoadingSubscribe: true,
                isErrorSubscribe: false,
                isSuccessSubscribe: false,
                objSubscribe: null
            };
        case EDITORIAL_CARD_FETCH_DATA_SUCCESS:
            return {
                ...state,
                isLoadingEditorial: false,
                isErrorEditorial: false,
                isSuccessEditorial: true,
                //errorGamerCard: null,
                editorialData: action.payload
            };
        case EDITORIAL_CARD_HAS_ERROR:
            return {
                ...state,
                isLoadingEditorial: false,
                isErrorEditorial: true,
                isSuccessEditorial: false,
                //errorGamerCard: action.payload,
                //gamerCardData: null
            };
        case IS_EDITORIAL_CARD_LOADING:
            return {
                ...state,
                isLoadingEditorial: true,
                isErrorEditorial: false,
                isSuccessEditorial: false,
                //errorGamerCard: null,
                //gamerCardData: null
            };
        case IS_DREAM_TEAM_LOADING: {
            return {
                ...state,
                isDreamTeamLoading: action.payload
            };
        }
        case DREAM_TEAM_HAS_ERROR: {
            return { ...state, dreamTeamHasError: action.payload };
        }
        case DREAM_TEAM_SUCCESS: {
            return { ...state, dreamTeam: action.payload['Data']['Value'] };
        }
        case IS_EOS_LOADING: {
            return {
                ...state,
                isEosLoading: action.payload
            };
        }
        case EOS_HAS_ERROR: {
            return { ...state, finalPoints: action.payload };
        }
        case EOS_FETCH_DATA_SUCCESS: {
            return { ...state, finalPoints: action.payload['Data']['Value'].eosGamedays, eosStats: action.payload['Data']['Value'].eosStats };
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/HomeReducer.js